/* LEMEIN - stop the page jolting when you change colourway.
   Prestige ProductGallery.onVariantChange_fn calls scrollIntoView() on the newly-first
   .product-gallery__media. On desktop the media are STACKED VERTICALLY, so that call
   scrolls the whole document and the breadcrumb jumps out of view.
   Forcing block/inline "nearest" keeps the mobile carousel moving horizontally but
   scrolls the page only if the image is genuinely off-screen. */
(function () {
  var orig = Element.prototype.scrollIntoView;

  Element.prototype.scrollIntoView = function () {
    if (this.classList && this.classList.contains("product-gallery__media")) {
      return orig.call(this, { block: "nearest", inline: "nearest", behavior: "smooth" });
    }
    return orig.apply(this, arguments);
  };
})();

/* lm-thumb-nav 2026-09-17: on desktop the gallery stacks its media in one clamped box, so a
   thumbnail click had no effect — the theme's carousel scrolls horizontally, and the
   scrollIntoView patch above downgrades its page-scroll fallback. Promote the clicked media to
   the first grid row instead: deterministic, and unaffected by the theme's adaptive-height reset. */
(function(){
  var MQ = '(min-width: 1000px)';
  function carouselOf(el){ var g = el.closest ? el.closest('.product-gallery') : null; return (g || document).querySelector('scroll-carousel'); }
  function clear(car){ for(var i = 0; i < car.children.length; i++) car.children[i].style.gridRow = ''; car.scrollTop = 0; }
  function promote(car, id){
    if(!car) return;
    if(!window.matchMedia(MQ).matches){ clear(car); return; }
    var visible = [], i, cell;
    for(i = 0; i < car.children.length; i++){
      cell = car.children[i];
      if(cell.hasAttribute('hidden')) { cell.style.gridRow = ''; } else { visible.push(cell); }
    }
    if(visible.length < 2) { clear(car); return; }
    var row = 2;
    for(i = 0; i < visible.length; i++){
      visible[i].style.gridRow = visible[i].getAttribute('data-media-id') === id ? '1' : String(row++);
    }
    car.scrollTop = 0;
  }
  document.addEventListener('click', function(event){
    var thumb = event.target && event.target.closest ? event.target.closest('.product-gallery__thumbnail') : null;
    if(!thumb) return;
    var car = carouselOf(thumb), id = thumb.getAttribute('data-media-id');
    if(!car || !id) return;
    promote(car, id);
    setTimeout(function(){ promote(car, id); }, 0);
  }, true);
  function watch(){
    var galleries = document.querySelectorAll('.product-gallery'), i;
    for(i = 0; i < galleries.length; i++){
      var gallery = galleries[i], car = gallery.querySelector('scroll-carousel');
      if(!car || car.__lmThumbNav) continue;
      car.__lmThumbNav = new MutationObserver(function(){ clear(this); }.bind(car));
      car.__lmThumbNav.observe(gallery, { attributes: true, attributeFilter: ['hidden'], subtree: true });
    }
  }
  function clearAll(){ var cars = document.querySelectorAll('scroll-carousel'); for(var i = 0; i < cars.length; i++) clear(cars[i]); }
  try { window.matchMedia(MQ).addEventListener('change', clearAll); } catch(e) { window.addEventListener('resize', clearAll); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  document.addEventListener('shopify:section:load', watch);
})();
